// Hook générique « action portée par l'URL » : ?action=new-… déclenche
// l'ouverture de la popup de création de la page cible (ajout rapide du
// shell mobile, liens SmartFeed…), puis nettoie le paramètre pour qu'un
// rafraîchissement ou un retour arrière ne rouvre pas la fenêtre.
// Même philosophie que le traitement ?action=new-task de MesToDo.
import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const useUrlAction = (action, onTrigger) => {
  const location = useLocation()
  const navigate = useNavigate()
  const handledRef = useRef(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('action') !== action) return

    // Garde-fou : ne déclenche qu'une fois par URL (StrictMode, re-render).
    const key = `${location.pathname}${location.search}`
    if (handledRef.current === key) return
    handledRef.current = key

    onTrigger()

    // Retire uniquement `action` : les autres paramètres (filtres, vue,
    // date…) restent intacts.
    params.delete('action')
    navigate(
      { pathname: location.pathname, search: params.toString() },
      { replace: true }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])
}

export default useUrlAction
